// assets/custom-retinol-columns.js
// Section: Custom Retinol Columns
// Loaded via: {{ 'custom-retinol-columns.js' | asset_url | script_tag }} (defer)

(function () {
  'use strict';

  // Wait for jQuery and Slick to be available
  function waitForDependencies(callback) {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      callback();
    } else {
      setTimeout(function() {
        waitForDependencies(callback);
      }, 100);
    }
  }

  class CustomRetinolColumns {
    constructor(el) {
      this.section = el;
      this.slider = el.querySelector('[data-slider-id]');
      
      if (!this.slider) return;
      
      waitForDependencies(() => {
        this._init();
      });
    }

    _init() {
      const $slider = jQuery(this.slider);
      $slider.slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        accessibility: true,
        focusOnSelect: true,
        swipe: true,
        touchMove: true,
        responsive: [
          {
            breakpoint: 1180,
            settings: {
              slidesToShow: 2.25,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              arrows: false
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1.25,
              slidesToScroll: 1,
              dots: false,
              arrows: false
            }
          }
        ]
      });

      // Enhance keyboard navigation
      this._setupKeyboardNav($slider);
    }

    _setupKeyboardNav($slider) {
      const slides = this.slider.querySelectorAll('.custom-retinol-columns__slide');
      
      slides.forEach((slide, index) => {
        slide.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $slider.slick('slickGoTo', index);
            slide.focus();
          }
        });
      });
    }

    destroy() {
      if (!this.slider) return;
      const $slider = jQuery(this.slider);
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  // Initialize all instances of this section on the page
  function initSections() {
    document.querySelectorAll('[data-section-type="custom-retinol-columns"]').forEach(el => {
      if (!el.dataset.initialized) {
        const instance = new CustomRetinolColumns(el);
        el._customRetinolInstance = instance;
        el.dataset.initialized = 'true';
      }
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }

  // Support Shopify Theme Editor live reload
  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('[data-section-type="custom-retinol-columns"]');
    if (el && !el.dataset.initialized) {
      waitForDependencies(() => {
        const instance = new CustomRetinolColumns(el);
        el._customRetinolInstance = instance;
        el.dataset.initialized = 'true';
      });
    }
  });

  document.addEventListener('shopify:section:unload', e => {
    const el = e.target.querySelector('[data-section-type="custom-retinol-columns"]');
    if (el && el.dataset.initialized) {
      const instance = el._customRetinolInstance;
      if (instance) {
        instance.destroy();
      }
      delete el._customRetinolInstance;
      delete el.dataset.initialized;
    }
  });
})();
